import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InAppNotificationsEffects } from 'src/app/in-app-notifications/store/effects/in-app-notifications.effects';
import { inAppNotificationsReducer } from 'src/app/in-app-notifications/store/reducers/in-app-notifications.reducer';
import { inAppNotificationsFeatureKey } from 'src/app/in-app-notifications/store/selectors/in-app-notifications.selectors';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(inAppNotificationsFeatureKey, inAppNotificationsReducer),
        EffectsModule.forFeature([InAppNotificationsEffects])
    ]
})
export class InAppNotificationsStoreModule {}
